module.exports = __webpack_public_path__ + "img/marker5.3dbf6005.webp";